export function normalizeString(str: string): string {
  return str
    .normalize('NFD')
    .replace(/[^a-zA-Zs]/g, '')
    .toLowerCase();
}
